'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Response = exports.Request = exports.Headers = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.clearFixtures = clearFixtures;
exports.replaceFixtures = replaceFixtures;
exports.loadFixture = loadFixture;
exports.mockJsonResponse = mockJsonResponse;
exports.fetch = fetch;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Using the Fetch Ponyfill to avoid modifying `window`
 *
 * Github's fetch polyfill documentation: https://github.com/github/fetch
 */
var FetchPonyfill = require('fetch-ponyfill')({ Promise: _promise2.default });
var Headers = FetchPonyfill.Headers,
    Request = FetchPonyfill.Request,
    Response = FetchPonyfill.Response;


var FIXTURE_MUST_BE_RESPONSE = new Error('Fixture must be a Response object');

var responseConstructor = new Response().constructor;

var fixtures = {};

function isValidFixture(fixture, url, method) {
  if (fixture && fixture.constructor === responseConstructor) return true;

  console.error('Invalid fixture for ' + url + ' [' + method + ']'); // eslint-disable-line no-console

  throw FIXTURE_MUST_BE_RESPONSE;
}

function normalizeMethod() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GET';

  // Normalize method case so 'post' or 'POST' are equivalent
  return typeof method === 'string' ? method.toUpperCase() : 'GET';
}

function clearFixtures() {
  fixtures = {};
}

function replaceFixtures(newFixtures) {
  fixtures = newFixtures;
}

function loadFixture(fixture, url) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';

  if (typeof url !== 'string') return;

  method = normalizeMethod(method);

  if (isValidFixture(fixture, url, method)) {
    if ((0, _typeof3.default)(fixtures[url]) !== 'object') fixtures[url] = {};

    fixtures[url][method] = fixture;
  }
}

function mockJsonResponse() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var statusText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'OK';
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return new Response((0, _stringify2.default)(data, null, 2), { headers: headers, status: status, statusText: statusText });
}

function fetch(url, options) {
  if (global && global.__FETCH_FIXTURES__) {
    var method = normalizeMethod(options && options.method);
    var fixture = fixtures[url] && fixtures[url][method];

    if (isValidFixture(fixture, url, method)) {
      return new _promise2.default(function (resolve) {
        resolve(fixture);
      });
    }
  }

  return FetchPonyfill.fetch(url, options);
}

exports.Headers = Headers;
exports.Request = Request;
exports.Response = Response;
//# sourceMappingURL=fetch.js.map